import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import Image from 'next/image';
import Link from 'next/link'

import { useGetRandomNewsQuery } from '../Store/Features/NewsletterAPI'

export default function WhitePaper({ customClass }) {
    const { data: posts, error, isLoading } = useGetRandomNewsQuery('/newsletter-whitepaper/random-news')
    const [data, setData] = useState([])

    useEffect(() => {
        if (isLoading === false) {
            setData(posts)
        }
    }, [setData, posts, isLoading])

    return (
        data?.length > 0 && data != null && data != undefined && data[0]?.image &&
        <>
            <div className={customClass ? customClass + " " : "shadow-md rounded my-4 px-4 py-4"}>
                <h3 className="text-md pb-2 border-b-2 text-[#1b5df3] font-semibold">Newsletter / Whitepaper</h3>
                <div className="mt-3">
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, Autoplay]}
                        slidesPerView={1}
                        autoplay={{ delay: 5000 }}
                        loop={true}
                        navigation={{ nextEl: '.swiper-button-next-client', prevEl: '.swiper-button-prev-client' }}
                        pagination={{ clickable: true }}
                    >
                        {data?.map((item, index) => (
                            <SwiperSlide key={index}>
                                <Link href={process.env.APP_URL + '/whitepaper-newsletter/' + item?.slug}>
                                    <Image
                                        priority={true}
                                        src={process.env.IMG_CDN + item?.image}
                                        className='h-full w-full'
                                        width={2000}
                                        height={2000}
                                        alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                    />
                                </Link>
                                <div className='line-clamp-2 overflow-hidden mb-5'>
                                    <Link href={process.env.APP_URL + '/whitepaper-newsletter/' + item?.slug}>
                                        <p className='text-center my-2'>{item?.title}</p>
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
}
